import React, { lazy, Suspense } from 'react';

import clientOnly from '../../hoc/clientOnly';

const ColorPicker = lazy(() =>
  import(/* webpackChunkName: "ColorPicker" */ './ColorPicker')
);

const Loader = props => (
  <Suspense fallback={null}>
    <ColorPicker {...props} />
  </Suspense>
);

export default clientOnly(Loader);
